import React, { useId } from "react";
import { Radio as RadioPrimitive } from "@base-ui/react/radio";
import { RadioGroup as RadioGroupPrimitive } from "@base-ui/react/radio-group";

import { cn } from "@/lib/utils";

function RadioGroup({ className, ...props }: RadioGroupPrimitive.Props) {
  return <RadioGroupPrimitive data-slot="radio-group" className={cn("grid w-full gap-2", className)} {...props} />;
}

function RadioGroupItem({ className, ...props }: RadioPrimitive.Root.Props) {
  return (
    <RadioPrimitive.Root
      data-slot="radio-group-item"
      className={cn(
        "group/radio-group-item peer relative flex aspect-square size-4 shrink-0 rounded-full border border-input outline-none after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 cursor-pointer group-has-disabled/field:opacity-50 group-has-disabled/field:cursor-default aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 aria-invalid:aria-checked:border-primary dark:bg-input/30 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40 data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground dark:data-checked:bg-primary",
        className
      )}
      {...props}
    >
      <RadioPrimitive.Indicator data-slot="radio-group-indicator" className="flex size-4 items-center justify-center">
        <span className="absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-foreground" />
      </RadioPrimitive.Indicator>
    </RadioPrimitive.Root>
  );
}

interface RadioButtonProps extends RadioPrimitive.Root.Props {
  label: React.ReactNode;
}

function RadioGroupButton({ label, disabled, className, ...props }: RadioButtonProps) {
  const reactId = useId();
  const id = props.id ?? reactId;
  return (
    <div className="group flex flex-row items-center gap-2" data-disabled={disabled ? true : undefined}>
      <RadioGroupItem className={className} {...props} disabled={disabled} id={id} />
      <label
        htmlFor={id}
        className="text-foreground cursor-pointer group-data-[disabled]:cursor-default group-data-[disabled]:opacity-50 text-sm"
      >
        {label}
      </label>
    </div>
  );
}

RadioGroup.displayName = "RadioGroup";
RadioGroupItem.displayName = "RadioGroupItem";
RadioGroupButton.displayName = "RadioGroupButton";

const RadioGroupNamespace = Object.assign(RadioGroup, {
  Button: RadioGroupButton,
  Item: RadioGroupItem,
});
export { RadioGroupNamespace as RadioGroup };
